import setForceResolveState from 'owa-readwrite-recipient-well/lib/actions/setForceResolveState';
import RecipientWellWithFindControlViewState from 'owa-recipient-types/lib/types/RecipientWellWithFindControlViewState';
import onEditingItemStarted from 'owa-unified-people-picker/lib/utils/onEditingItemStarted';

const resolveAllUnresolvedRecipients = (
    viewState: RecipientWellWithFindControlViewState,
    startAtIndex?: number
) => {
    setForceResolveState(viewState, true);

    let indexToRemove = -1;
    for (let i = startAtIndex || 0; i < viewState.recipients.length; i++) {
        const recipient = viewState.recipients[i];

        if (!recipient.isValid) {
            indexToRemove = i;
            break;
        }
    }

    if (indexToRemove !== -1) {
        onEditingItemStarted(viewState.recipients[indexToRemove], indexToRemove, viewState);
    } else {
        // base case for when we're done resolving
        setForceResolveState(viewState, false);
    }
};

export default resolveAllUnresolvedRecipients;
